import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Rect, { width: "8", height: "6", x: "8", y: "12", rx: "1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M15 12v-2a3 3 0 1 0-6 0v2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FileLock";
const FileLock = memo(themed(Icon));
export {
  FileLock
};
//# sourceMappingURL=file-lock.js.map
